import React from "react";
import { useAuthenticationContext } from "@/store/authContext/authContext";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import NewDeckModalContent from "@/components/deck/NewDeckModalContent";

type ModalProps = {
  type: string | null; // Type of modal to display
};

// Not sure how modals are going to develop as the app grows, so for now
// I'm keeping it simple with a single Modal component that can handle different types. - Matt

const Modal: React.FC<ModalProps> = ({ type }) => {
  const { state, dispatch } = useAuthenticationContext();

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      dispatch({ type: "closeModalAction" }); // Dispatch close action
    }
  };

  let modalContent = null;
  switch (type) {
    case "new-deck":
      modalContent = <NewDeckModalContent />;
      break;
  }

  return (
    <Dialog open={state.modalState.isOpen} onOpenChange={handleOpenChange}>
      <DialogContent
        className={`${type === "new-deck" ? "sm:max-w-[920px]" : "sm:max-w-[600px]"}`}
      >
        {modalContent}
      </DialogContent>
    </Dialog>
  );
};

export default Modal;
